import Immutable from 'immutable';

export default class EntityStore extends Immutable.Record({
  ctor: null,
  entities: Immutable.Map(),
  errors: Immutable.Map(),
  loading: Immutable.Set(),
}) {
  getEntity(id) {
    return this.entities.get(id);
  }
  setEntity(id, value) {
    const ctor = this.ctor;
    return this.withMutations(
      (obj) => obj
        .update('entities', (entities) =>
          entities.set(id, !ctor || value instanceof ctor ? value : new ctor(value)))
        .update('loading', (loading) => loading.delete(id))
    );
  }
  setEntities(pairs) {
    const ctor = this.ctor;
    return this.withMutations(
      (obj) => obj
        .update('entities', mutateReduce(pairs, (entities, [id, value]) =>
          entities.set(id, !ctor || value instanceof ctor ? value : new ctor(value))))
        .update('loading', mutateReduce(pairs, (loading, [id]) => loading.delete(id)))
    );
  }
  deleteEntities(ids) {
    return this.update('entities', mutateReduce(
      ids, (entities, id) => entities.delete(id)
    ));
  }
  isLoading(id) {
    return !!this.loading.get(id, false);
  }
  startLoading(ids) {
    return this.update('loading', (loading) => loading.union(ids));
  }
  stopLoading(ids) {
    return this.update('loading', (loading) => loading.subtract(ids));
  }
  getError(id) {
    return this.errors.get(id);
  }
  setError(id, error) {
    return this.withMutations(
      (obj) => obj
        .update('loading', (loading) => loading.delete(id))
        .update('errors', (errors) => errors.set(id, error))
    );
  }
  setErrors(pairs) {
    return this.withMutations(
      (obj) => obj
        .update('errors', mutateReduce(pairs, (errors, [id, error]) =>
          errors.set(id, error)))
        .update('loading', (loading) => loading.subtract(pairs.map(([id]) => id)))
    );
  }
  clearErrors(ids) {
    return this.update('errors', mutateReduce(ids, (errors, id) =>
      errors.delete(id)
    ));
  }
}

function mutateReduce(collection, fn) {
  return ((immutable) =>
    immutable.withMutations((mutable) =>
      collection.reduce(fn, mutable)));
}
